import { lkSegmentIds } from '@web/common/ExternalConfig/getters'

export function useNewLk () {
  function checkShowNewLk (userSegments: Segment[]) {
    return userSegments?.some(segment => lkSegmentIds().includes(segment.id)) ?? false
  }

  return {
    checkShowNewLk
  }
}
